<template>
  <div class="main main-raised">
    <div class="container" id="formContainer" ref="formContainer">
      <div class="section">
        <div class="row">
          <br />
          <div class="ml-auto mr-auto">
            <div class="full col-sm-12 col-md-8 offset-md-2">
              <div class="row article">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h1>Kiedy złożyć wypowiedzenie?</h1>
                    
                    <h2>Te wskazówki podpowiedzą, czy pora na zmianę pracy.</h2>
                    
                  </div>
                  <div class="panel-body">
                    <div>
                      <span
                        >W życiu wielu z nas przychodzi moment, w którym
                        zaczynamy się zastanawiać nad zmianą pracy. Czasem jest
                        to decyzja trudna, czasami przychodzi z łatwością.</span
                      >
                    </div>
                    <br />
                    <div>
                      <span
                        >Poniżej znajdziecie wskazówki oznajmiające, że macie do
                        czynienia z tym drugim i czas <a href="http://szybkiewypo.pl" title="Szybkie Wypo - generator wypowiedzenia umowy">złożyć wypowiedzenie</a> by
                        pożegnać się z dotychczasowym miejscem pracy.</span
                      >
                    </div>
                    <br />
                    <div>
                      <ul>
                        <li>
                          <p>
                            Czy praca, która wcześniej pozwalała na
                            samorealizację od dłuższego czasu Ci ciąży? Nie masz
                            już ochoty chodzić do pracy? To może być chwilowe,
                            ale takie chwile nie trwają miesiącami.
                          </p>
                        </li>

                        <li>
                          <p>
                            Od pierwszych godzin poniedziałku czekasz na piątek.
                            W niedzielę czujesz bluesa. Sunday bluesa.
                          </p>
                        </li>

                        <li>
                          <p>
                            Nadgodziny, które są standardem, a nie wyjątkiem?
                            Brak czasu na życie? Życie od weekendu do weekendu?
                            Nie, te hasła to nie randomowy strumień świadomości.
                            To sygnały, że warto przynajmniej rozważyć zmianę
                            pracy.
                          </p>
                        </li>

                        <li>
                          <p>
                            Pieniądze to nie wszystko, ale umówmy się -
                            wynagrodzenie jest ważne. Jeśli w Twojej skrzynce
                            lądują kolejne <a href="http://devpurge.com/linkedxd" target="_blank" title="Linked xD - generator wiadomości HR">wiadomości od rekruterów</a>, może warto
                            dać sobie szansę na finansowy upgrade.
                          </p>
                        </li>

                        <li>
                          <p>
                            Nie pamiętasz kiedy wypadał Twój ostatni urlop - w
                            końcu jak są żniwa to rolnik pracuje. Tylko plonów
                            ciągle brak.
                          </p>
                        </li>

                        <li>
                          <p>
                            Lub odwrotnie - już w kilka dni po powrocie z
                            wypoczynku odczuwasz narastające zajechanie. Po
                            każdym powrocie.
                          </p>
                        </li>

                        <li>
                          <p>
                            To normalne, jeśli po pracy potrzebny Ci moment na
                            ogólną dekompresję lub reset, by nie myśleć o
                            obowiązkach po godzinach. Gorzej, jeśli rozluźnienie
                            coraz częściej wymaga zakończenia dnia kilkoma
                            głębszymi.
                          </p>
                        </li>

                        <li>
                          <p>
                            Idąc dalej tym tropem - czy praca śni Ci się już po
                            nocach, a skumulowany stres wybudza Cię z bijącym
                            sercem? Taaak.
                          </p>
                        </li>

                        <li>
                          <p>
                            Ocena okresowa jest z góry układana tak żeby nikt
                            nie dostał podwyżki i wszyscy w firmie zdają sobie z
                            tego sprawę.
                          </p>
                        </li>

                        <li>
                          <p>
                            Jeśli jednak w jakiś sposób uda się awansować, nowe
                            stanowisko oznacza zwiększenie zakresu obowiązków,
                            ale nie wynagrodzenia. Awans poziomy - najlepszą
                            nagrodą jest praca.
                          </p>
                        </li>

                        <li>
                          <p>
                            Nie nadążasz czytać maili pożegnalnych pisanych
                            przez kolejne osoby na <a href="http://szybkiewypo.pl" title="Szybkie Wypo - generator wypowiedzenia umowy">wypowiedzeniu</a>. W zasadzie
                            raczej zastanawiasz się: ‘kto dzisiaj’?
                          </p>
                        </li>

                        <li>
                          <p>
                            To nie koniec. Jeśli ludzie rzucają papierem, ktoś
                            będzie musiał przejąć ich obowiązki. Zastanów się,
                            czy nie będziesz to Ty - i po ilu osobach.
                          </p>
                        </li>

                        <li>
                          <p>
                            Czy firma wyraźnie i od dłuższego czasu tonie?
                            Zastanów się, czy jej kiepskie perspektywy nie
                            pociągną Cię za sobą.
                          </p>
                        </li>

                        <li>
                          <p>
                            Powiedzenie mówi, że przychodzi się do pracy, a
                            odchodzi od szefa. Jeżeli Twój przełożony wyraźnie
                            nie ogarnia, nie wspiera Cię lub relacje po prostu
                            dalekie są od profesjonalnie poprawnych - dużo
                            tracisz. Zwłaszcza nerwów.
                          </p>
                        </li>

                        <li>
                          <p>
                            Nie pamiętasz kiedy ostatni raz się czegoś
                            nauczyłeś. Pracy powinien towarzyszyć rozwój,
                            inaczej Twoja kariera będzie stała w miejscu. Jeśli
                            taka stagnacja się utrzymuje przez dłuższy okres
                            warto ją przerwać.
                          </p>
                        </li>

                        <li>
                          <p>
                            Chaos organizacyjny - cytując klasyka: nie wiadomo
                            gdzie głowa, a gdzie noga. Jeśli nic nie wskazuje na
                            to, że mogłaby nastąpić poprawa/reorganizacja -
                            uciekaj!
                          </p>
                        </li>
                      </ul>
                    </div>
                    <br/>
                    <div>
                      <span>
                        Dajcie znać co Was zmotywowało do rozstania z
                        pracodawcą.</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Article",
  created: function () {
      document.title = "Kiedy złożyć wypowiedzenie? - Szybkiewypo.pl";
  },
};
</script>


<style scoped>
 .article h2 {
   font-size: 1.9rem;
 }
 .article .panel-body {
   padding-top: 20px;
 }
 .article {
   padding-top: 35px;
 }

 .article .panel-body span {
   font-size: 1.1rem;
   text-align: justify;
 }

  .article .panel-body p {
   font-size: 1rem;
 }
</style>